"use client";

import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  useTheme,
} from "@mui/material";
import { ReactNode, useState } from "react";

export const SLAccordionLight = ({
  title,
  children,
  defaultExpanded = false,
}: {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
}) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Accordion
      variant="outlined"
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={{
        backgroundColor: theme.palette.background.default,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          justifyContent: "flex-start",
          "& .MuiAccordionSummary-content": {
            flexGrow: 0,
          },
          "& .MuiAccordionSummary-expandIconWrapper": {
            marginLeft: 1,
          },
        }}
      >
        <Typography variant="body1" color="text.secondary">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{expanded ? children : null}</AccordionDetails>
    </Accordion>
  );
};
